<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'masterdata.cutting.dialog.httperror' | translate }}</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">{{ 'masterdata.cutting.rule' | translate }}</h1>

	<mat-dialog-content style="padding-top: 20px">
		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['name'].invalid && controls['name'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.name.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.name.label' | translate }}</mat-label>
				<input maxlength="50" matInput formControlName="name" />
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog dialog-priority">
				@if (controls['priority'].invalid && controls['priority'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.priority.errors.invalid' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.priority.label' | translate }}</mat-label>
				<input matInput type="number" min="0" step="1" formControlName="priority" />
			</mat-form-field>
		</div>

		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.cutting.description' | translate }}</mat-label>
			<input maxlength="100" matInput formControlName="description" />
		</mat-form-field>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.batch-type.label' | translate }}</mat-label>
				<input maxlength="255" matInput formControlName="batchType" />
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['material'].invalid && controls['material'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.material.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.material.label' | translate }}</mat-label>
				<input maxlength="255" matInput formControlName="material" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.profile' | translate }}</mat-label>
				<input maxlength="255" matInput formControlName="profile" />
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['machine'].invalid && controls['machine'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.machines.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.machines.label' | translate }}</mat-label>
				<input maxlength="255" matInput formControlName="machine" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['setup'].invalid && controls['setup'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.setups.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.setups.label' | translate }}</mat-label>
				<mat-select formControlName="setup">
					<mat-option [value]="null">{{ 'masterdata.cutting.dialog.none' | translate }}</mat-option>
					@for (setup of availableSetups?.items; track setup) {
					<mat-option [value]="setup.self">{{ setup.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.segregation' | translate }}</mat-label>
				<input maxlength="255" matInput formControlName="segregation" />
			</mat-form-field>
		</div>
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.cutting.disableOptimization' | translate }}</mat-label>
			<mat-select formControlName="disableOptimization">
				<mat-option [value]="false">{{ 'general.table.status.active' | translate }}</mat-option>
				<mat-option [value]="true">{{ 'general.table.status.inactive' | translate }}</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			@if (controls['logisticsFormula'].errors?.['api']; as error) {
			<mat-error>{{ error }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.logisticsFormula' | translate }}</mat-label>
			<textarea matInput formControlName="logisticsFormula" rows="3" maxlength="1000"></textarea>
		</mat-form-field>

		<div class="dialog-checkbox">
			<mat-checkbox formControlName="useCoatingInOptimization">{{ 'masterdata.cutting.useCoatingInOptimization' | translate }}</mat-checkbox>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'masterdata.cutting.dialog.cancel' | translate }}</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">{{ 'masterdata.cutting.dialog.ok' | translate }}</button>
	</mat-dialog-actions>
</form>
